import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { InlineWidget } from "react-calendly";
import "../styles/flow-journey.css";

const heroTestimonials = [
  {
    quote:
      "The word that comes to mind is haven. It was a space to connect to myself, to pause, and give attention to myself.",
    cite: "OD Consultant, Mexico",
  },
  {
    quote:
      "Your work provides a playground where I can evolve — without needing to be anyone.",
    cite: "ICF Certified Coach, USA",
  },
  {
    quote:
      "What you're creating is the kind of stuff the world needs. I want you to make this big.",
    cite: "Flow Journey Pilot Participant",
  },
];

// const assessmentSteps = [
//   "Where you are now",
//   "The instincts running the show",
//   "What looks like defensiveness",
//   "Moving toward flow",
//   "Opening up",
//   "A closer look inward",
// ];

const specs = [
  { label: "Sessions", val: "90 minutes, weekly, on Circle" },
  { label: "Group", val: "5–6 people · Kept small for trust and depth" },
  {
    label: "Between",
    val: "Curated readings, guided journaling, personalized practices",
  },
  { label: "Guides", val: "Alec Lance and Stan Cross" },
  { label: "Platform", val: "Circle · One login, everything in one place" },
  { label: "Price", val: "Various options" },
];

const phases = [
  {
    name: "Survival Instinct Awareness",
    desc: "See the hidden force that's been running the show — and watch its grip begin to loosen.",
  },
  {
    name: "Frozen Identity",
    desc: "Recognize the shell you built for safety — and see it clearly for the first time.",
  },
  {
    name: "Letting Go",
    desc: "Release the identity that protected you — and discover what's been waiting underneath.",
  },
  {
    name: "Flow States",
    desc: "Experience the natural, effortless state that's always been available to you.",
  },
  {
    name: "Flow Identity",
    desc: "Move from occasional flow to a new, stable way of being — present, creative, alive.",
  },
  {
    name: "Synergistic Intelligence",
    desc: "Offer your awakened self to something greater — and discover what becomes possible together.",
  },
];

const howCards = [
  {
    num: "01",
    name: "Dialogue-driven group sessions",
    desc: "Each live session blends reflection with deep, co-creative conversation. You'll engage in honest dialogue with peers who are on the same path — moving from reactivity toward something more open and alive.",
  },
  {
    num: "02",
    name: "Personalized practice between sessions",
    desc: "The real transformation happens between sessions. Curated readings, guided journaling, and personalized practices based on your Flow Identity profile — designed to cultivate insight and help you embody new ways of being.",
  },
  {
    num: "03",
    name: "Your AI-powered companion",
    desc: "Meet the Flow Journey Bot — your personal AI guide. It serves as both a mirror, reflecting your unique insights and blind spots, and a sherpa, offering thoughtful nudges to deepen your transformation between sessions.",
  },
];

// const howFlowSteps = [
//   { label: "Flow Identity Assessment", desc: "Calibrate your starting point" },
//   { label: "Circle Invitation", desc: "Join your cohort space" },
//   { label: "6 Weekly Sessions", desc: "Live, guided, small group" },
//   { label: "Alumni Community", desc: "Stay connected after" },
// ];

// const circleFeatures = [
//   "Six-phase curriculum with practices and reflections",
//   "Your Flow Identity results and personalized path",
//   "Live session recordings to revisit anytime",
//   "The Flow Journey Bot — your personal AI guide",
//   "Direct connection with your cohort between sessions",
//   "Alumni community access when your journey ends",
// ];

const liveFeatures = [
  "6 live sessions · 90 min each · weekly on Circle",
  "Small group of 5–6 · kept intimate for trust and depth",
  "Flow Identity Assessment + personalized path",
  "Flow Journey Bot — your personal AI companion",
  " Circle platform access for your cohort",
  "Flow Journey Journal — physical, mailed to you",
  "SI Alumni Community invite after journey ends",
];

const asyncFeatures = [
  "Full six-phase curriculum at your own pace",
  "Flow Journey Bot — your personal AI companion",
  "Async Circle platform access",
  "Flow Journey Journal — physical, mailed to you",
];

// const scholarshipFeatures = [
//   "Full live cohort experience — everything included",
//   "One spot reserved per cohort",
//   "Application based on readiness, not means testing",
//   "Conversation with Alec or Stan before acceptance",
// ];

// const botFeatures = [
//   {
//     label: "A mirror",
//     desc: "— reflects your unique insights and blind spots back to you in real time",
//   },
//   {
//     label: "A sherpa",
//     desc: "— offers thoughtful nudges and prompts to deepen your transformation between sessions",
//   },
//   {
//     label: "Personalized",
//     desc: "— trained on your Flow Identity profile and the full Flow Journey curriculum",
//   },
//   {
//     label: "Always available",
//     desc: "— insight doesn't wait for the next session",
//   },
// ];

// const calTimes = [
//   "Mon, Jun 23 · 9:00 AM",
//   "Mon, Jun 23 · 11:00 AM",
//   "Tue, Jun 24 · 10:00 AM",
//   "Tue, Jun 24 · 2:00 PM",
//   "Wed, Jun 25 · 9:00 AM",
// ];

// Shared fade-up variant
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

export default function FlowJourney() {


  return (
    <>
      {/* ── HERO ── */}
      <section className="fj-hero">
        <div className="fj-hero-left">
          <p className="section-label section-label--dark">The Flow Journey</p>
          <h1>
            From fear to flow.
            <br />
            <em>Six weeks.</em>
            <br />
            One small group.
          </h1>
          <p className="fj-hero-sub">
            A guided, cohort-based journey for leaders and coaches ready to move
            from survival mode to a way of being that's more present, more
            creative, and more alive.
          </p>
          {/* <div className="fj-hero-details">
            {[
              { label: "Format", val: "90 min · weekly · Circle" },
              { label: "Group size", val: "5–6 people" },
              { label: "Duration", val: "6 weeks" },
              { label: "Next cohort", val: "Forming now" },
            ].map(({ label, val }) => (
              <div className="fj-hero-detail" key={label}>
                <span className="fj-hero-detail-label">{label}</span>
                <span className="fj-hero-detail-val">{val}</span>
              </div>
            ))}
          </div> */}
          <div className="fj-hero-actions">
            <Link to="/calendly" className="btn-sand">
              Talk with Alec or Stan →
            </Link>
            <Link to="/flow-journey#apply" className="btn-ghost-light-fj">
              Already know it's time? See the next cohort
            </Link>
            <p className="fj-hero-note">
              Groups kept intentionally small · Scholarship spots available
            </p>
          </div>
        </div>

        <div className="fj-hero-right-block">
          <p className="section-label section-label--dark">From the journey</p>

          <h3 className="fj-hero-testimonial-title">
            Real people. Real transformation.
          </h3>

          <p className="fj-hero-testimonial-sub">
            2025 cohorts included participants from Japan, England, the
            Netherlands, Ecuador, Mexico, and the United States.
          </p>

          <div className="fj-hero-divider" />

          {heroTestimonials.map(({ quote, cite }, i) => (
            <div className="fj-hero-testimonial" key={i}>
              <blockquote>"{quote}"</blockquote>
              <cite>{cite}</cite>
            </div>
          ))}
        </div>
      </section>

      {/* ── WHAT IT IS ── */}
      <motion.section
        className="fj-what"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
      >
        <div className="fj-what-inner">
          <div className="fj-what-left">
            <p className="section-label">What it is</p>
            <h2>Not a course. Not a workshop. A journey.</h2>
            <p className="fj-what-body">
              Over six weeks, you'll <strong>begin noticing patterns</strong>{" "}
              that have quietly shaped your life for years. Not because someone
              tells you they're there, but because you start seeing them for
              yourself.
            </p>
            {/* <p className="fj-what-body">
              It begins where most of us actually live — inside the tight grip
              of the survival instinct — and walks you, step by step, toward the
              <strong> natural intelligence</strong> that was always waiting underneath.
            </p> */}
            <p className="fj-what-body">
              <strong>Different lives. The same human questions.</strong> Every
              cohort proves — across cultures, roles, and worldviews — the same
              patterns keep showing up, and the same shifts keep happening.
            </p>
          </div>

          <div className="fj-what-right">
            <p className="section-label">The essentials</p>
            <div className="fj-what-specs">
              {specs.map(({ label, val }) => (
                <div className="fj-spec-item" key={label}>
                  <div className="fj-spec-label">{label}</div>
                  <div className="fj-spec-val">
                    {label === "Price" ? (
                      <>
                        <a
                          href="#apply"
                          className="fj-spec-link"
                          onClick={(e) => {
                            e.preventDefault();
                            document
                              .getElementById("apply")
                              ?.scrollIntoView({ behavior: "smooth" });
                          }}
                        >
                          Various options ↓
                        </a>
                      </>
                    ) : (
                      val
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.section>

      {/* ── JOURNEY PHASES ── */}
      <section className="journey">
        <div className="journey-header">
          <p className="section-label">The six phases</p>
          <h2 className="section-title">Six phases. One transformation.</h2>
        </div>

        <div className="journey-steps">
          {phases.map(({ name }, i) => (
            <motion.div
              className="step"
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{
                duration: 1.3,
                delay: i * 0.15,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <div className={`step-dot${i === 5 ? " active" : ""}`} />
              <div className="step-num">Phase {i + 1}</div>
              <div className="step-name">{name}</div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="fj-how">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{
            duration: 1.4,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <p className="section-label section-label--dark">How it works</p>
          <div className="fj-how-header">
            <h2>Three elements. One integrated experience.</h2>
            <p>
              Every part of the Flow Journey is designed to work together — live
              sessions, personal practice, and AI support woven into a single,
              coherent path.
            </p>
          </div>

          <div className="fj-how-grid">
            {howCards.map(({ num, name, desc }) => {
              const linkText = "Flow Journey Bot";
              const idx = desc.indexOf(linkText);
              return (
                <div className="fj-how-card" key={num}>
                  <div className="fj-how-card-num">{num}</div>
                  <div className="fj-how-card-name">{name}</div>
                  <div className="fj-how-card-desc">
                    {idx === -1 ? (
                      desc
                    ) : (
                      <>
                        {desc.slice(0, idx)}
                        <a
                          href="https://chatgpt.com/g/g-69d940a3ff288191bbbe4c69d0b0d235-flow-journey-bot"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {linkText}
                        </a>
                        {desc.slice(idx + linkText.length)}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* <div className="fj-how-flow">
            {howFlowSteps.map(({ label, desc }) => (
              <div className="fj-how-flow-step" key={label}>
                <strong>{label}</strong>
                {desc}
              </div>
            ))}
          </div> */}
        </motion.div>
      </section>

      {/* ── CIRCLE PLATFORM ── */}
      {/* <motion.section
        className="fj-circle-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        <div className="fj-circle-left">
          <p className="section-label">One platform, one home</p>
          <h2>Everything lives on Circle — no extra apps, no friction.</h2>
          <p className="fj-circle-body">
            We know joining another platform feels like one more thing. That's
            why we've built the Flow Journey to live entirely within Circle —
            one login, one space, one continuous experience from first session
            through alumni community.
          </p>
          <div className="fj-circle-steps">
            {[
              "Take the Flow Identity Assessment — the same starting point every participant begins with",
              "If it feels aligned, join the waitlist and connect with Alec or Stan",
              "Receive your Circle invitation — one click to join",
              "Your cohort space and materials are waiting, alongside your assessment results",
            ].map((step, i) => (
              <div className="fj-circle-step" key={i}>
                <div className="fj-circle-step-num">{i + 1}</div>
                <div>{step}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="fj-circle-right">
          <h4>What's inside your Circle space</h4>
          {circleFeatures.map((f) => (
            <div className="fj-circle-feature" key={f}>
              <div className="fj-circle-check">✓</div>
              <div>{f}</div>
            </div>
          ))}
        </div>
      </motion.section> */}

      {/* ── FREE ENTRY — assessment ── */}
      {/* <section className="fj-free-entry">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{
            duration: 1.4,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <p className="section-label" style={{ justifyContent: "center" }}>
            Start here, it's free
          </p>
          <h2>
            Not sure if this is for you?
            <br />
            Take the Flow Identity Assessment.
          </h2>
          <p>
            The Flow Identity Assessment is a short, revealing assessment that
            offers a closer look at how old instincts might be shaping the way
            you lead, relate, and see yourself. It takes about 10 minutes — and
            it's the same starting point every Flow Journey participant begins
            with.
          </p>
          <div className="fj-assessment-card">
            <div className="fj-assessment-card-head">
              <div className="fj-assessment-card-title">
                Flow Identity Assessment
              </div>
              <div className="fj-assessment-card-badge">Free</div>
            </div>
            <p className="fj-assessment-card-desc">
              Six stages of self-inquiry. Designed to surface patterns that
              often stay hidden — and to help you recognize whether the Flow
              Journey is your next step.
            </p>
            <div className="fj-assessment-steps">
              {assessmentSteps.map((step, i) => (
                <div className="fj-assessment-step" key={i}>
                  <div className="fj-assessment-step-num">{i + 1}</div>
                  <div>{step}</div>
                </div>
              ))}
            </div>
            <Link to="/assessment" className="btn-moss">
              Take the Flow Identity Assessment — free →
            </Link>
          </div>
        </motion.div>
      </section> */}

      {/* ── PRICING ── */}
      <motion.section
        className="fj-pricing"
        id="apply"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={fadeUp}
      >
        <div className="fj-pricing-header">
          <p className="section-label">Investment</p>
          <h2>
            Real transformation takes time, presence, and care — from both of
            us.
          </h2>
          <p>
            The Flow Journey is priced to reflect the depth of the work — and to
            attract people who are genuinely ready to do it. Scholarship spots
            are available every cohort. The async version is always open.
          </p>
        </div>

        <div className="fj-pricing-grid">
          {/* Live cohort */}
          <motion.div
            className="fj-price-card featured"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{
              duration: 0.8,
              delay: 0,
              ease: "easeOut",
            }}
          >
            <div className="fj-price-badge primary">Live cohort</div>
            <div className="fj-price-tag">Guided · Small group</div>
            <div className="fj-price-name">
              Flow Journey
              <br />
              Live Experience
            </div>
            <div className="fj-price-amount">
              <div className="fj-price-num">$799</div>
              <div className="fj-price-period">per person</div>
            </div>
            <div className="fj-price-qualifier">
              6 weeks · 5–6 people · Next cohort forming now
            </div>
            <div className="fj-price-divider" />
            <div className="fj-price-features">
              {liveFeatures.map((f) => (
                <div className="fj-price-feature" key={f}>
                  <div className="fj-price-check moss">✓</div>
                  <div>{f}</div>
                </div>
              ))}
            </div>
            <a
              href="https://synergistic-intelligence-302819.circle.so/forms/c2139320"
              className="btn-earth"
              target="_blank"
              rel="noopener noreferrer"
            >
              Join the waitlist →
            </a>
          </motion.div>

          {/* Async / self-paced */}
          <motion.div
            className="fj-price-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{
              duration: 0.8,
              delay: 0.6,
              ease: "easeOut",
            }}
          >
            <div className="fj-price-badge secondary">Self-paced · Beta</div>
            <div className="fj-price-tag async">Async · Available now</div>
            <div className="fj-price-name">
              Flow Journey
              <br />
              Self-Paced
            </div>
            <div className="fj-price-amount">
              <div className="fj-price-num">$199</div>
              <div className="fj-price-period">introductory</div>
            </div>
            <div className="fj-price-qualifier">Your pace · Your schedule</div>
            <div className="fj-price-divider" />
            <div className="fj-price-features">
              {asyncFeatures.map((f) => (
                <div className="fj-price-feature" key={f}>
                  <div className="fj-price-check bark">✓</div>
                  <div>{f}</div>
                </div>
              ))}
            </div>
            <Link to="/async-flow-journey" className="btn-outline-moss">
              Start the async version →
            </Link>
          </motion.div>

          {/* Scholarship */}
          {/* <motion.div
            className="fj-price-card scholarship"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{
              duration: 0.8,
              delay: 1.2,
              ease: "easeOut",
            }}
          >
            <div className="fj-price-badge soft">1 spot per cohort</div>
            <div className="fj-price-tag schol">
              Scholarship · Application required
            </div>
            <div className="fj-price-name">
              Flow Journey
              <br />
              Scholarship Track
            </div>
            <div className="fj-price-amount" style={{ marginTop: "0.5rem" }}>
              <div className="fj-price-num small">
                Email to
                <br />
                inquire
              </div>
            </div>
            <div className="fj-price-qualifier">
              For those called but financially constrained
            </div>
            <div className="fj-price-divider" />
            <div className="fj-price-features">
              {scholarshipFeatures.map((f) => (
                <div className="fj-price-feature" key={f}>
                  <div className="fj-price-check soft">✓</div>
                  <div>{f}</div>
                </div>
              ))}
            </div>
            <a
              href="mailto:alec@synergisticintelligence.com"
              className="btn-outline-neutral"
            >
              Email us →
            </a>
          </motion.div> */}
        </div>

        <p className="fj-pricing-note">
          Scholarship spots are also available. Reach out to{" "}
          <a href="mailto:stan@synergisticintelligence.com">Stan</a> or{" "}
          <a href="mailto:alec@synergisticintelligence.com">Alec</a> directly.
        </p>
      </motion.section>

      {/* ── BOT SECTION ── */}
      {/* <motion.section
        className="fj-bot-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        <div className="fj-bot-left">
          <p className="section-label">Your AI guide</p>
          <h2>The Flow Journey Bot — a mirror and a sherpa.</h2>
          <p className="fj-bot-body">
            Whether you've just taken the Flow Identity Assessment or are midway
            through your journey, the Flow Journey Bot is trained to help you
            explore how your core instincts shape your path — and how they can
            transform from barriers into strengths.
          </p>
          <p className="fj-bot-body">
            It's not a chatbot. It's a reflective companion designed to meet you
            exactly where you are.
          </p>
          <a
            href="https://chatgpt.com/g/g-69d940a3ff288191bbbe4c69d0b0d235-flow-journey-bot"
            className="btn-earth"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chat with the Flow Journey Bot →
          </a>
        </div>
        <div className="fj-bot-right">
          {botFeatures.map(({ label, desc }) => (
            <div className="fj-bot-feature" key={label}>
              <div className="fj-bot-icon">◎</div>
              <div>
                <strong>{label}</strong>
                {desc}
              </div>
            </div>
          ))}
        </div>
      </motion.section> */}

      {/* ── CALENDLY BRIDGE ── */}
      <section className="fj-calendly">
        <div className="fj-calendly-inner">
          <div className="fj-calendly-hero">
            <p className="section-label section-label--dark">
              The human bridge
            </p>
            <h2>
              A personal conversation
              <br />
              with Alec or Stan.
            </h2>
            <p className="fj-calendly-body">
              Before you apply for the Flow Journey, we'd love to meet you. A
              15-minute conversation to understand where you are, answer any
              questions you have, and make sure the timing and fit are right.
            </p>
            <p className="fj-calendly-body">
              No pressure. No pitch. The Flow Journey works best when the fit is
              genuine — and this conversation is how we both find out.
            </p>
            <div className="fj-calendly-meta">
              <div className="fj-calendly-meta-item">
                <span>⏱</span>
                <span>15 minutes</span>
              </div>
              <div className="fj-calendly-meta-item">
                <span>🎥</span>
                <span>Video call</span>
              </div>
              <div className="fj-calendly-meta-item">
                <span>✦</span>
                <span>Free</span>
              </div>
            </div>
          </div>

          <div className="fj-calendly-hosts">
            <div className="fj-calendly-host-card">
              <div className="fj-calendly-avatars">
                <div className="fj-calendly-avatar">A</div>
              </div>

              <p className="fj-calendly-name">Alec Lance</p>

              <p className="fj-calendly-role">
                Co-Founder, Synergistic Intelligence
              </p>

              <div className="fj-calendly-divider" />

              <p className="fj-calendly-instruction">
                Select a time that works for you
              </p>

              <div className="fj-calendly-widget-wrap">
                <InlineWidget
                  url="https://calendly.com/alec-synergisticintelligence/post-fia-connect-with-alec"
                  styles={{
                    height: "700px",
                    width: "100%",
                  }}
                  pageSettings={{
                    backgroundColor: "f8f4ee",
                    primaryColor: "5c6b4a",
                    textColor: "2e2820",
                    hideEventTypeDetails: true,
                    hideLandingPageDetails: true,
                  }}
                />
              </div>
            </div>

            <div className="fj-calendly-host-card">
              <div className="fj-calendly-avatars">
                <div className="fj-calendly-avatar">S</div>
              </div>

              <p className="fj-calendly-name">Stan Cross</p>

              <p className="fj-calendly-role">
                Co-Founder, Synergistic Intelligence
              </p>

              <div className="fj-calendly-divider" />

              <p className="fj-calendly-instruction">
                Select a time that works for you
              </p>

              <div className="fj-calendly-widget-wrap">
                <InlineWidget
                  url="https://calendly.com/stan-synergisticintelligence/30min"
                  styles={{
                    height: "700px",
                    width: "100%",
                  }}
                  pageSettings={{
                    backgroundColor: "f8f2e8",
                    primaryColor: "6f8f5a",
                    textColor: "2f2923",
                    hideEventTypeDetails: true,
                    hideLandingPageDetails: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      {/* <section className="fj-final-cta">
        <motion.div
          className="fj-final-cta-content"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{
            duration: 1.6,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <p className="section-label" style={{ justifyContent: "center" }}>
            Your next step
          </p>

          <h2>
            Ready to explore what's possible?
            <br />
            <em>Start with the assessment.</em>
          </h2>

          <p className="fj-final-cta-body">
            The Flow Identity Assessment is the same starting point every
            participant begins with — free, and about 10 minutes.
          </p>

          <div className="fj-cta-group">
            <Link to="/assessment" className="btn-primary-dark">
              Take the Flow Identity Assessment →
            </Link>
          </div>

          <a href="#calendly" className="fj-final-cta-secondary">
            Prefer to talk it through first? Book a conversation with Alec or
            Stan →
          </a>
        </motion.div>
      </section> */}
    </>
  );
}